import React from 'react';
import { UnavailableShiftTranslationKeys } from './UnavailableShiftFilterTypes';
import { CheckboxList } from '../../../shared';
import { useTranslation } from 'react-i18next';
import { useLabelTextMap } from '../useLabelMap';
import { getCheckboxItems } from '../getCheckboxItems';
import { Link } from '@amzn/atoz-web/Link';
import { Routes } from '@amzn/atoz-shiftapp-initializer';
export var UnavailableShiftFilter = function (_a) {
    var unavailableShiftFilterState = _a.unavailableShiftFilterState, unavailableShiftFilterOptions = _a.unavailableShiftFilterOptions, onFilterStateChange = _a.onFilterStateChange, showLocationEligibilityLink = _a.showLocationEligibilityLink;
    var t = useTranslation().t;
    var labelText = useLabelTextMap(UnavailableShiftTranslationKeys);
    var labelLink = new Map();
    if (showLocationEligibilityLink) {
        var exceedsHoursCapLabelLink = (React.createElement(Link, { dataTestId: "exceeds-hours-cap-learn-more", padding: { left: 'S100' }, href: Routes.LocationEligibility }, t('shift_management_views_filters_Unavailable_exceedHoursCap_learnMore')));
        labelLink.set(UnavailableShiftTranslationKeys.EXCEEDS_HOURS_CAP, exceedsHoursCapLabelLink);
    }
    var checkboxListItems = getCheckboxItems(unavailableShiftFilterOptions, {
        labelTextMap: labelText,
        labelLinkMap: labelLink
    });
    return (React.createElement(CheckboxList, { title: t('shift_management_views_filters_Unavailable_title'), dataTestId: "unavailable-shift-filters", checkboxState: unavailableShiftFilterState, onStateChange: onFilterStateChange, checkboxListItems: checkboxListItems }));
};
